export const DEPARTURE_TYPE_OPTIONS = Object.freeze({
  LOGISTIC_OPERATOR: 10,
  PAQUERYPOINT: 20,
});

export const OTHER_NOTIFIER_TYPE = Object.freeze({ label: 'Otra', value: 0 });

export const DEPARTURE_TYPE_NAME_OVERRIDES = Object.freeze({
  [DEPARTURE_TYPE_OPTIONS.LOGISTIC_OPERATOR]: 'OPL',
});

export const SELECTABLE_DEPARTURE_TYPE_OPTIONS = Object.freeze([
  DEPARTURE_TYPE_OPTIONS.LOGISTIC_OPERATOR,
  DEPARTURE_TYPE_OPTIONS.PAQUERYPOINT,
]);
